import HeroBG from "../../Components/Style/HeroBG"
import LiquidGlass from "../../Components/Style/LiquidGlass"
import ContainerVerification from "./Components/ContainerVerification"
export default function VerificationGoogle() {
  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark p-4">
      <div className="absolute inset-0 z-0 transition-none">
        <HeroBG />
      </div>
      <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
        <ContainerVerification/>
      </LiquidGlass>
    </div>
  )
}
